import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faHome, faUsers, faCodePullRequest, faSitemap, faGear, faChartLine, faUserCog, faFileInvoice, faCreditCard } from '@fortawesome/free-solid-svg-icons'
import { useAuthorization } from '@/composables/useAuthorization'
import { computed } from 'vue'

export default {
  name: 'SideNav',
  components: {
    FontAwesomeIcon
  },
  setup () {
    const {
      canAccessUsersPage,
      canAccessOrganizationsPage,
      canAccessRequests,
      hasRole,
      hasPermission
    } = useAuthorization()
    const isCurrentUserGlobalAdmin = () => hasRole('bits_admin') || hasRole('superadmin')

    // Filter menu items based on user permissions
    const filteredMenuItems = computed(() => {
      const allMenuItems = [
        { title: 'Home', icon: faHome, route: '/' },
        { title: 'Dashboard', icon: faChartLine, route: '/dashboard' },
        {
          title: 'Requests',
          icon: faCodePullRequest,
          route: '/requests',
          show: computed(() => canAccessRequests.value && !isCurrentUserGlobalAdmin())
        },
        {
          title: 'Organizations',
          icon: faSitemap,
          route: '/organizations',
          show: computed(() => canAccessOrganizationsPage.value && !hasRole('customer_owner') && !hasRole('resource_manager'))
        },
        {
          title: 'Invoices',
          icon: faFileInvoice,
          route: '/invoices',
          show: computed(() => isCurrentUserGlobalAdmin())
        },
        {
          title: 'Payments',
          icon: faCreditCard,
          route: '/payments',
          show: computed(() => isCurrentUserGlobalAdmin())
        },
        {
          title: 'Users',
          icon: faUsers,
          route: '/users',
          show: computed(() => (canAccessUsersPage.value || hasRole('resource_manager')) && !hasRole('customer_user'))
        },
        {
          title: 'Role Management',
          icon: faUserCog,
          route: '/roles',
          show: computed(() => !hasRole('resource_manager') && !hasRole('customer_user'))
          // Currently allowing all authenticated users as per requirements except resource_manager and customer_user
        },
        {
          title: 'Settings',
          icon: faGear,
          route: '/settings',
          show: computed(() => isCurrentUserGlobalAdmin() || hasRole('customer_owner'))
        }
      ]

      return allMenuItems.filter(item => {
        // Don't show any menu items for basic_user
        if (hasRole('basic_user')) {
          return false
        }

        if (item.show !== undefined) {
          return item.show.value
        }
        if (item.requiresPermission) {
          return hasPermission(item.requiresPermission)
        }
        return true
      })
    })

    return {
      filteredMenuItems
    }
  },
  data () {
    return {
      isOpen: false,
      displayType: 'block'
    }
  },
  computed: {
    menuItems () {
      return this.filteredMenuItems
    }
  },
  methods: {
    navigateTo (route) {
      this.$router.push(route)
    }
  }
}
